/* global window */
import { PLATFORM } from 'Constants/device.APP_TARGET';
import { PLATFORM as mobile } from 'Constants/device.mobile';
import { DESKTOPXL } from 'Constants/device.desktop';

export const isMobile = PLATFORM === mobile;

export const isScreenAboveDesktopXl = () => {
    if (typeof window === 'undefined') {
        return false; // Default to false for SSR
    }
    return window.innerWidth > DESKTOPXL;
};
